import { lazy } from 'react'
import menu from './menu'


function menuToArr(arr) {
  // 存放处理后的数组
  const newArr = [];
  function traverse(data) {
    // 将对象转为数组
    const itemArr = Array.isArray(data) ? data : [data];
    // 遍历数组
    for (const item of itemArr) {
      // 如果有 children，进行递归
      if (item.children) {
        traverse(item.children);
      } else {
        newArr.push(item);
      }
    }
  }
  traverse(arr);
  return newArr;
}

const menuList = menuToArr(menu)

menuList.unshift( {path: '/home/report-form', exact: true, redirect: menuList[0].path })

const routesList = [
	// 首页
	{
		path: '/',
		exact: true,
		redirect: '/home'
	},
	{
		path: '/home',
		component: lazy(() => import('@/views/Home/Home')),
		exact: false,
		meta: {
			title: '首页',
			requireAuth: true
		},
		children: [
			{
				path: '/home',
				exact: true,
				redirect: '/home/report-form'
			},
			{
				path: '/home/report-form',
				component: lazy(() => import('@/views/Home/ReportForm/ReportForm')),
				exact: false,
				meta: {
					title: '统计报表',
					requireAuth: true
				},
				children: menuList
			}
		]
	},
	// 登录
	{
		path: '/login',
		component: lazy(() => import('@/views/LogIn/LogIn')),
		exact: true,
		meta: {
			title: '登录',
			requireAuth: false
		}
	},
	// //二级路由
	// {
	//     path: '/Basis',
	//     // 使用懒加载的方法
	//     component: lazy(() => import('../views/Basis/Basis.js')),
	//     // 如果要求严格路径
	//     exact: false,
	//     //子路由
	//     children: [
	//         {
	//             path: '',
	//             // index属性来指定默认路由 path需要为空
	//             index: true,
	//             component: lazy(() => import('../views/BasisLevel/BasisLevel.js')),
	//             exact: false,
	//             meta: {
	//                 title: '二级路由1',
	//                 //是否需要登录
	//                 requireAuth: true
	//             }
	//         }, {
	//             path: 'BasisLevel2',
	//             component: lazy(() => import('../views/BasisLevel2/BasisLevel2.js')),
	//             exact: false,
	//             meta: {
	//                 title: '二级路由2',
	//                 //是否需要登录
	//                 requireAuth: true
	//             }
	//         }
	//     ]
	// },
	// //404页面
	{
		path: '*',
		exact: false,
		component: lazy(() => import('@/views/NotFound/NotFound')),
		meta: {
			title: '404',
			//是否需要登录
			requireAuth: false
		}
	}
]
export default routesList